import React from "react";
import { Field } from "formik";
import PropTypes from "prop-types";
import { createUseStyles } from "react-jss";
import _ from "lodash";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import { commonInputGroupStyles } from "..";
import { useEffect } from "react";
import jssVariables from "../../../../jss_setup";
import { InlineIcon } from "@iconify/react";
import { toast } from "react-toastify";

const integersFieldStyles = createUseStyles({
  inputGroup: (props) => ({
    ...commonInputGroupStyles.inputGroup,
    alignContent: "baseline",
    ..._.get(props, "customStyles.inputGroup", {}),
  }),
  label: (props) => ({
    ...commonInputGroupStyles.label,
    ..._.get(props, "customStyles.label", {}),
  }),
  reactSelectStyles: (props) => ({
    ...commonInputGroupStyles.inputGroup,
    height: "5rem",
    border: `1px solid ${jssVariables.colors.base_color}`,

    ..._.get(props, "customStyles.reactSelectStyles", {}),
  }),
  errorMessage: (props) => ({
    ...commonInputGroupStyles.errorMessage,
    ..._.get(props, "customStyles.errorMessage", {}),
  }),
  picker: (props) => ({
    ...commonInputGroupStyles.inputGroup,
    alignItems: "center",
    display: "grid",
    gridTemplateColumns: "1fr repeat(3, max-content)",
    gridGap: jssVariables.normal_gap,
    fontSize: "x-large",
    border: `1px solid ${jssVariables.colors.base_color}`,
    borderRadius: "5px",
    height: "3rem",
    padding: `calc(${jssVariables.normal_gap} / 2)`,
    ..._.get(props, "customStyles.picker", {}),
  }),
  btn: (props) => ({
    borderRadius: "50%",
    fontSize: "x-large",
    background: jssVariables.colors.background.lightGray,
    cursor: "pointer",
    ..._.get(props, "customStyles.btn", {}),
  }),
});

const IntegersFieldComponent = ({
  field,
  form: { setFieldValue },
  title,
  minValue,
  maxValue,
  customStyles,
  messageWhenMin,
}) => {
  const classes = integersFieldStyles({ customStyles });

  useEffect(() => {
    if (!field.value) {
      setFieldValue(field.name, minValue);
    }
  }, []);

  return (
    <div className={classes.picker}>
      <span>{title}</span>
      <InlineIcon
        id="minusIcon"
        icon="ic:round-minus"
        className={classes.btn}
        onClick={(e) => {
          e.preventDefault();
          if (field.value <= minValue) {
            setFieldValue(field.name, minValue);
            if (messageWhenMin) {
              toast.info(messageWhenMin);
            }
          } else if (field.value > minValue) {
            setFieldValue(field.name, field.value - 1);
          }
        }}
      />
      <span className={classes.pax}>{field.value}</span>
      <InlineIcon
        id="plusIcon"
        icon="ic:round-plus"
        className={classes.btn}
        onClick={(e) => {
          e.preventDefault();
          if (field.value < minValue) {
            setFieldValue(field.name, minValue);
          } else if (field.value < maxValue) {
            setFieldValue(field.name, field.value + 1);
          }
        }}
      />
    </div>
  );
};
IntegersFieldComponent.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  customStyles: PropTypes.object,
  messageWhenMin: PropTypes.string,
};

export const IntegersField = ({
  name,
  label,
  options,
  isMulti,
  placeholder,
  closeMenuOnSelect,
  disabled = false,
  title,
  customStyles,
  minValue = 0,
  maxValue = 100,
  messageWhenMin,
}) => {
  const classes = integersFieldStyles({ isDisabled: disabled, customStyles });

  return (
    <div className={classes.inputGroup}>
      <label className={classes.label}>{label}</label>
      <Field
        name={name}
        options={options}
        isMulti={isMulti}
        placeholder={placeholder}
        closeMenuOnSelect={closeMenuOnSelect}
        component={IntegersFieldComponent}
        disabled={disabled}
        title={title}
        minValue={minValue}
        maxValue={maxValue}
        customStyles={customStyles}
        messageWhenMin={messageWhenMin}
      />
    </div>
  );
};
IntegersField.defaultProps = {
  title: "",
  name: "",
  label: "",
  options: [],
  isMulti: false,
  closeMenuOnSelect: true,
  disabled: false,
  messageWhenMin: "",
  minValue: 0,
  maxValue: 100,
};
IntegersField.propTypes = {
  placeholder: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  options: PropTypes.array.isRequired,
  isMulti: PropTypes.bool,
  customStyles: PropTypes.object,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  disabled: PropTypes.bool,
  closeMenuOnSelect: PropTypes.bool,
  messageWhenMin: PropTypes.string,
};
